<template lang="html">
	<div class="inner-modal">
		<div class="body-modal">
			<div class="title-gold">
				Vous avez émis le souhait d'obtenir une réponse d'un professinnel contrôlé exerçant une activité réglementée
			</div>
			<div class="body-standard">
				<p>Conformément aux principes de la loi du 6 janvier 1978 relative à l’informatique aux fichiers et aux libertés nous vous rappelons que la présente collecte d’information ainsi que leur exploitation sont effectuées dans votre intérêt et ont pour finalité de permettre au professionnel de fournir un conseil adapté à votre problématique.</p>
				<p>La qualité de son travail dépendra étroitement de la véracité, de l’exactitude et de l’exhaustivité de vos réponses à ce questionnaire.</p>
				<p>Si vous ne communiquez pas les informations requises, votre conseiller ne pourra pas poursuivre sa mission et devra s’abstenir de vous recommander les opérations, instruments et services relevant de son activité CIF. Il ne pourra vous fournir qu’une prestation d’information ou de recherche, une mission relevant d’un autre métier réglementé ou de la sphère non financière.</p>
				<p>Votre conseiller s’est engagé au respect de règles de bonne conduite incluant le secret professionnel et la protection de vos données personnelles.</p>
			</div>
			<div class="title-grey">
				Nouveau
			</div>
			<div class="body-standard">
				<p>Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé.</p>
				<p>Elles sont conservées pendant [durée_de_conservation] et sont destinées [destinataires_des_données]</p>
				<p>Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant : [service_chargé_du_droit_d’acces : Nom, adresse électronique et/ou postale]</p>
				<p>Vous reconnaissez avoir connaissance des tarifs de votre conseiller, de ses méthodes de travail et avoir en votre possession sa fiche d’information légale ANACOFI-CIF."</p>
			</div>
			<div class="ctn-cta row">
				<div class="btn btn-gold" @click="close">Fermer</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LegalEstate',
	methods: {
		close () {
			this.$emit('close')
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>

<style lang="scss" scoped>
	.body-modal {
		max-width: 700px;
		padding: 4rem !important;
	}

	.title-gold {
		font-size: 1.2rem;
		margin-bottom: 2rem;
	}

	.title-grey {
		margin-top: 4rem;
	}

	.body-standard {
		font-size: 0.9rem;
		margin: 1rem 0;

		p {
			margin-bottom: 0.5rem;
		}
	}

	.ctn-cta {
		margin-top: 4rem;
	}
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/modal/LegalEstate.vue